<section class="dialog-content-container">
  <div class="custom-icon close" (click)="closeDialog()"></div>
  <section class="form-type-container">
    <h1>Contact {{ title }}</h1>

    <div class="contact-details">
      <div class="contact-wrapper">
        
        @if (contact) {
          @if (browserSize !== 'small') {
            <div class="custom-icon profile"></div>
          }

          <div class="details-wrapper">
            @if (contact.Name) {
              <div class="contact-name">{{ contact.Name }}</div>
            }
            @if (contact.Title) {
              <div class="contact-title">{{ contact.Title }}</div>
            }
            @if (contact.Email) {
              <div class="contact-email">
                <div class="custom-icon email_dark">email icon</div>
                <a href="mailto:{{contact.Email}}">{{ contact.Email }}</a>
              </div>
            }
            @if (contact.Phone) {
              <div class="contact-phone">
                <div class="custom-icon phone_dark">phone icon</div>
                <a href="tel:{{contact.Phone}}">{{ contact.Phone }}</a>
              </div>
            }
          </div>
        } @else if (errorMessage) {
          <div class="details-wrapper">Contact information is not available</div>
        }
      </div>
    </div>
  </section>
</section>
